import React from 'react';
import { withRouter } from 'react-router-dom';
import {
    Card, CardHeader, CardContent, Input, ButtonLayout, ButtonPrimary,
} from 'up-design-system-gex';
import Loader from 'up-design-system-gex/build/components/Loader'
import { parseToken, saveToken } from '../Auth';
import API from '../api';

class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            token: "",
            isLoading: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleLogin(e) {
        e.preventDefault();

        saveToken(this.state.token).then(() => {
            API.defaults.headers.common['X-Authorization'] = parseToken();
            let state = this.props.location.state
            if(state && state.id)
            {
                this.props.history.push("/refund/" +  state.id);
            }
            else
                this.props.history.push("/");
        });
    }

    render() {
        return (
            <Card>
                <CardHeader title={<h2 className='h4'>Prihlásiť sa cez token</h2>} />
                <CardContent style={{ "padding": "1.5rem" }}>
                    <form onSubmit={this.handleLogin}>
                        <Input name="token" id="token" label="Token" type="text" isRequired value={this.state.token}
                            onChange={this.handleInputChange}
                        />
                        <ButtonLayout className="align-items-right" direction={{
                            "m": "horizontal",
                        }}>
                            {this.state.isLoading ?
                                <Loader
                                    id="loader" isCentered size="large"
                                /> :
                                <ButtonPrimary submit>
                                    Prihlásiť sa
                                </ButtonPrimary>
                            }
                        </ButtonLayout>
                    </form>
                </CardContent>
            </Card >
        );
    }
}

export default withRouter(LoginPage);